import { render, staticRenderFns } from "./DeudaEmpresas.vue?vue&type=template&id=45577063&scoped=true&"
import script from "./DeudaEmpresas.vue?vue&type=script&lang=js&"
export * from "./DeudaEmpresas.vue?vue&type=script&lang=js&"
import style0 from "./DeudaEmpresas.vue?vue&type=style&index=0&id=45577063&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45577063",
  null
  
)

export default component.exports